import React from 'react';

const OrderItemsDisplay = ({ orderDetails }) => {
    // Handle null/undefined
    if (!orderDetails) return <span className="text-gray-400 text-xs">No items</span>;

    // Parse if string
    let items;
    try {
        items = typeof orderDetails === 'string'
            ? JSON.parse(orderDetails)
            : orderDetails;
    } catch (e) {
        return <span className="text-red-400 text-xs">Invalid data</span>;
    }

    // Handle empty array
    if (!Array.isArray(items) || items.length === 0) {
        return <span className="text-gray-400 text-xs">No items</span>;
    }

    return (
        <div className="text-xs space-y-1 max-w-xs">
            {items.map((item, idx) => {
                // Get the selected pack price (e.g., PackOf1, PackOf2, etc.)
                const selectedPack = item.selectedPack || 'PackOf1';
                const itemPrice = parseFloat(item[selectedPack] || item.MCSellingPrice || 0);
                const quantity = item.quantity || 1;
                const total = itemPrice * quantity;

                return (
                    <div key={idx} className="border-l-2 border-blue-400 pl-2 py-1">
                        <div className="font-semibold text-gray-800">{item.ItemName || 'Unknown Item'}</div>
                        <div className="text-gray-600">
                            Pack: {selectedPack} | Qty: {quantity} × ₹{itemPrice.toFixed(2)} = ₹{total.toFixed(2)}
                        </div>
                        {item.Brand && <div className="text-gray-500 text-xs">Brand: {item.Brand}</div>}
                    </div>
                );
            })}
            <div className="font-bold text-gray-900 pt-1 border-t">
                Total Items: {items.length}
            </div>
        </div>
    );
};

export default OrderItemsDisplay;
